import {
  ShieldCheckIcon,
  BuildingStorefrontIcon,
  RectangleGroupIcon,
  MagnifyingGlassIcon,
  UserGroupIcon,
  BanknotesIcon,
  ChatBubbleLeftRightIcon,
  ChartBarIcon,
  CalculatorIcon,
  RocketLaunchIcon,
  MapIcon,
  ClipboardDocumentCheckIcon,
  DocumentCheckIcon,
  BookOpenIcon,
  LightBulbIcon,
  BriefcaseIcon,
} from '@heroicons/react/24/outline';

// Helper function to check if a feature is enabled
const hasFeature = (features = [], featureName) => {
  if (!Array.isArray(features)) return false;
  return features.some((f) => String(f) === featureName || String(f) === `${featureName}_type`);
};

// Dynamic function that accepts features and builds the categories array
export const getCategoriesData = (features = []) => {
  // Growth tools can be expanded conditionally based on feature flags
  const growthTools = [
    { id: 'valuation', label: 'Valuation', labelKey: 'succession.tools.valuation', route: '/succession/valuation', icon: ChartBarIcon },
    { id: 'cfa', label: 'Cash Flow Analysis', labelKey: 'succession.tools.cfa', route: '/succession/calculators/cfa', icon: CalculatorIcon },
    { id: 'map', label: 'Master Action Plan', labelKey: 'succession.tools.map', route: '/succession/advisor-map', icon: MapIcon },
  ];

  // Add Recruitment if student_connection_platform feature is enabled
  if (hasFeature(features, 'student_connection_platform')) {
    growthTools.push({ id: 'hiring', label: 'Recruitment', labelKey: 'succession.tools.hiring', route: '/hiring', icon: BriefcaseIcon });
  }

  // Sprint is always available
  growthTools.push({ id: 'sprint', label: 'Sprint', labelKey: 'succession.tools.sprint', route: '/sprints', icon: ShieldCheckIcon });

  // Recreated from Polymet prototype structure
  return [
    {
      id: 'succession',
      label: 'Succession',
      labelKey: 'succession.categories.succession',
      color: 'text-succession-primary',
      bgColor: 'bg-blue-50',
      tools: [
        { id: 'valuation', label: 'Valuation', labelKey: 'succession.tools.valuation', route: '/succession/valuation', icon: ChartBarIcon },
        { id: 'planning', label: 'Planning', labelKey: 'succession.tools.planning', route: '/succession/plans', icon: ClipboardDocumentCheckIcon },
        { id: 'deals', label: 'Deal Room', labelKey: 'succession.tools.deals', route: '/succession/deals', icon: RectangleGroupIcon },
        { id: 'ps', label: 'Partial Sales', labelKey: 'succession.tools.ps', route: '/succession/partial_sales', icon: BuildingStorefrontIcon },
      ],
    },
    {
      id: 'opportunity',
      label: 'Opportunities',
      labelKey: 'succession.categories.opportunity',
      color: 'text-succession-success',
      bgColor: 'bg-purple-50',
      tools: [
        { id: 'discovery', label: 'Discovery', labelKey: 'succession.tools.discovery', route: '/succession/search', icon: MagnifyingGlassIcon },
        { id: 'rolodex', label: 'My Rolodex', labelKey: 'succession.tools.rolodex', route: '/succession/rolodex', icon: UserGroupIcon },
        { id: 'teaming', label: 'Teaming', labelKey: 'succession.tools.teaming', comingSoon: true, icon: UserGroupIcon },
        { id: 'financing', label: 'Financing', labelKey: 'succession.tools.financing', route: '/succession/financing', icon: BanknotesIcon },
        { id: 'messages', label: 'Messages', labelKey: 'succession.tools.messages', route: '/succession/messages', icon: ChatBubbleLeftRightIcon },
      ],
    },
    {
      id: 'growth',
      label: 'Growth',
      labelKey: 'succession.categories.growth',
      color: 'text-succession-secondary',
      bgColor: 'bg-green-50',
      tools: growthTools,
    },
    {
      id: 'learn',
      label: 'Learn',
      labelKey: 'succession.categories.learn',
      color: 'text-succession-accent',
      bgColor: 'bg-orange-100',
      bgInline: '#FFF7ED',
      tools: [
        { id: 'education', label: 'Education', labelKey: 'succession.tools.education', route: '/succession/education', icon: BookOpenIcon },
        { id: 'insights', label: 'Insights', labelKey: 'succession.tools.insights', comingSoon: true, icon: LightBulbIcon },
      ],
    },
  ];
};

// Backward-compatible static export for callers that don't pass features
export const categoriesData = getCategoriesData();
